import React from 'react';

// Components
import ConfigurationCycleItem from '../ConfigurationCycleItem/ConfigurationCycleItem';
import InteractiveButton from '../InteractiveButton/InteractiveButton';
import { ButtonType } from '../../types/button-type';
import EmptyDataTable from '../EmptyDataTable/EmptyDataTable';
import { ConfigurationCycleOption } from '../ConfigurationCycle/ConfigurationCycle';
import ComponentNameCycleList from '../../enums/component-name-cycle-list.enum';

type ConfigurationCycleListProps = {
  dataName: string;
  disabled: boolean;
  editingController: string | null;
  listOptions: ConfigurationCycleOption[];
  onChange: (values: object) => void;
  selectAllOptions: (data: ConfigurationCycleOption[]) => void;
  resetAllOptions: (data: ConfigurationCycleOption[]) => void;
  selectedValues: string[] | null;
  updateEditingController?: (serial_number: string) => void;
};

const ConfigurationCycleList: React.FC<ConfigurationCycleListProps> = ({
  dataName,
  disabled,
  editingController,
  listOptions,
  onChange,
  selectAllOptions,
  selectedValues,
  updateEditingController,
  resetAllOptions,
}) => {
  const classNameList = `с-configuration-cycle-list__list relative overflow-hidden flex flex-auto flex-col gap-y-2 rounded-2xl border  p-7 bg-white dark:bg-boxdark shadow-default ${disabled ? ' pointer-events-none border-black before:bg-zinc-400 before:content-[\'\'] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-red-500 before:z-1' : 'border-primary'}`;

  const disabledButton = (listOptions.length === 0 || disabled);

  const getCheckedByName = (optionName: string) => {
    if (selectedValues) {
      const value = selectedValues.some((item) => item === optionName);
      return value;
    }
    return false;
  }

  const defaultListOptions = listOptions.map((item) => ({ ...item, checked: false }));

  const selectEveryOption = () => {
    selectAllOptions(listOptions);
  };

  const resetEveryOption = () => {
    resetAllOptions(listOptions);
  };

  return (
    <div
      className="с-configuration-cycle-list flex flex-col flex-auto">
      {(listOptions.length === 0 && !disabled) ? (
        <div className='с-configuration-cycle-list__empty-options relative overflow-hidden flex flex-auto flex-col justify-center gap-y-2 rounded-2xl border  p-7 bg-white dark:bg-boxdark shadow-default border-primary'>
          <EmptyDataTable className='border-none' text="NO OPTIONS AVAILABLE" />
        </div>
      ) : (
        <ul className={classNameList}>
          {defaultListOptions.map((option, index) => (
            <ConfigurationCycleItem
              key={`${option.name}-${index}`}
              onChange={onChange}
              name={option.name}
              checked={getCheckedByName(option.value)}
              value={option.value}
              editingController={editingController}
              updateEditingController={updateEditingController}
              viewEditAction={dataName === ComponentNameCycleList.Controllers}
            />
          ))}
        </ul>
      )}
      <div className="с-configuration-cycle-list__actions flex flex-row justify-center gap-x-4 px-6 pt-4">
        <InteractiveButton
          type={ButtonType.PrimaryInverse}
          text="None"
          onClick={resetEveryOption}
          disabled={disabledButton}
        />
        <InteractiveButton
          type={ButtonType.Primary}
          text="All"
          onClick={selectEveryOption}
          disabled={disabledButton}
        />
      </div>
    </div>
  );
};

export default ConfigurationCycleList;
